const { getOffsetTop } = window.BAO.Utils

class SectionHero extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    this.els.image.elements.forEach(imageEl => {
      if (!imageEl.offsetHeight) return

      const animationDuration = 10

      const amountToMoveY = parseFloat(imageEl.dataset.distanceY)

      const elementHeight = imageEl.offsetHeight

      const elementStartPoint = getOffsetTop(imageEl)
      const elementEndPoint = getOffsetTop(imageEl) + elementHeight

      if (this.lastKnownY <= elementStartPoint) {
        setTimeout(() => {
          imageEl.style.transform = `translate3d(0px, 0px, 0px)`
          imageEl.style.opacity = `1`
        }, animationDuration)

        return
      }

      if (this.lastKnownY > elementEndPoint) {
        setTimeout(() => {
          imageEl.style.transform = `translate3d(0px, ${amountToMoveY}px, 0px)`
          imageEl.style.opacity = `0.1`
        }, animationDuration)

        return
      }

      const totalScrollAmount = elementEndPoint - elementStartPoint

      const scrollYAsAPercentageOfJourney =
        (this.lastKnownY - elementStartPoint) / totalScrollAmount

      const transformAmountY = amountToMoveY * scrollYAsAPercentageOfJourney

      const opacityChange =
        1.1 - scrollYAsAPercentageOfJourney > 1
          ? 1
          : Math.round((1.1 - scrollYAsAPercentageOfJourney) * 100) / 100

      setTimeout(() => {
        imageEl.style.transform = `translate3d(0px, ${transformAmountY}px, 0px)`
        imageEl.style.opacity = `${opacityChange}`
      }, animationDuration)
    })
  }
}

if (!customElements.get('section-hero')) {
  customElements.define('section-hero', SectionHero)
}
